import React, { Component } from 'react';

import { trans } from '../../../../../localization/index';
import { COMMON_CONST } from '../../../../../constants/constants';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import NowDatePicker from '../../../../../components/Common/NowDatePicker';
import { isEmptyObject } from '../../../../../utils/utils';

class OutOfStockDishModal extends Component {
  handleChangeFrom = (date) => {
    const { outOfStockReq, handleChangeOutOfStock } = this.props;
    handleChangeOutOfStock({
      ...outOfStockReq,
      from: date,
    });
  };

  handleChangeTo = (date) => {
    const { outOfStockReq, handleChangeOutOfStock } = this.props;
    handleChangeOutOfStock({
      ...outOfStockReq,
      to: date,
    });
  };

  render() {
    const {
      outOfStockReq,
      handleAddOutOfStockList,
      handleChangeOutOfStock,
    } = this.props;
    const { from, to } = outOfStockReq;
    const isOpenModal = !isEmptyObject(outOfStockReq);
    return (
      <Modal
        isOpen={isOpenModal}
        width="400px"
        className="out-of-stock-dish-modal"
      >
        <ModalHeader>
          {trans('mod_detail_config_time_out_of_stock')}
        </ModalHeader>
        <ModalBody>
          <div>
            <span>
              <b>{trans('mod_detail_start_date')}</b>:
            </span>
            <br />
            <NowDatePicker
              enableTime
              value={from}
              dateFormat={COMMON_CONST.FormatDateTimeTypeView}
              onChange={selectedDates =>
                this.handleChangeFrom(selectedDates[0])
              }
            />
          </div>
          <div>
            <span>
              <b>{trans('mod_detail_end_date')}</b>:
            </span>
            <br />
            <NowDatePicker
              enableTime
              value={to}
              dateFormat={COMMON_CONST.FormatDateTimeTypeView}
              onChange={selectedDates => this.handleChangeTo(selectedDates[0])}
            />
          </div>
        </ModalBody>
        <ModalAction>
          <ModalButton onClick={handleAddOutOfStockList}>
            {trans('common_yes')}
          </ModalButton>
          <ModalButton
            type="cancel"
            onClick={() => handleChangeOutOfStock({})}
          >
            {trans('common_cancel')}
          </ModalButton>
        </ModalAction>
      </Modal>
    );
  }
}
export default OutOfStockDishModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/OutOfStockDishModal.jsx